import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Image404 from '../../assets/404_Image.svg';

const PageNotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = React.useState(3);

  // Auto redirect after 3 seconds
  React.useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleRedirect = () => {
    navigate('/');
  };

  return (
    <Container
      maxWidth="false"
      sx={{
        backgroundColor: 'white.main',
        minHeight: {
          xs: '100%',
          md: '100vh',
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: {
            xs: 2,
            md: 4,
          },
          width: '100%',
          maxWidth: {
            xs: '90%',
            md: 600,
          },
        }}
      >
        {/* 404 Image */}
        <Box
          sx={{
            width: '100%',
            position: 'relative',
            mb: 4,
          }}
        >
          <Box
            component={'img'}
            src={Image404}
            sx={{
              width: '100%',
              height: '100%',
              borderRadius: 4,
              boxShadow: 3,
            }}
          />

          {/* Redirect Button */}
          <Button
            variant="outlined"
            onClick={handleRedirect}
            sx={{
              position: 'absolute',
              right: {
                xs: 15,
                md: 28,
              },
              bottom: {
                xs: 50,
                md: 95,
              },
              zIndex: 1,
              width: {
                xs: 180,
                md: 240,
              },
              height: {
                xs: 30,
                md: 35,
              },
              border: 1.5,
              borderColor: '#ffa312',
              borderRadius: 6,
              backgroundColor: 'transparent',
              color: '#ffb600',
              boxShadow: 4,
              fontSize: {
                xs: '0.9rem',
                md: '1rem',
              },
              fontWeight: 600,
              textTransform: 'none',
              ':hover': {
                border: 1.5,
                color: 'white.main',
                borderColor: '#ffb600',
                backgroundColor: '#ffa312',
                transform: 'translateY(-2px)',
                boxShadow: 6,
              },
              transition: 'all 0.3s ease',
            }}
          >
            Back To Homepage in {countdown}
            {countdown !== 1 ? 's' : ''}
          </Button>
        </Box>

        {/* Additional Help Text */}
        <Box
          sx={{
            textAlign: 'center',
            mt: 2,
            px: 2,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontSize: {
                xs: '0.9rem',
                md: '1rem',
              },
              mb: 1,
            }}
          >
            The page you're looking for doesn't exist or has been moved.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              opacity: 0.8,
              fontSize: {
                xs: '0.8rem',
                md: '0.9rem',
              },
            }}
          >
            You'll be automatically redirected to the homepage, or click the button above.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default PageNotFound;
